<div fxLayout="row" fxLayoutAlign="start center center" style="width: 100%">


    <div fxLayout="column" fxFlex="100">

        <mat-table [dataSource]="finalForms" fxFlex="grow" style="width: 100%;">

            <ng-container matColumnDef="title">
                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="start center center" *matHeaderCellDef> Τίτλος
                </mat-header-cell>
                <mat-cell class="tableCell" fxLayoutAlign="start center center"
                          *matCellDef="let element"> {{element.title}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="published_at">
                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef> Ημ.
                    Δημοσίευσης
                </mat-header-cell>
                <mat-cell class="tableCell" fxLayoutAlign="center center center"
                          *matCellDef="let element"> {{element.published_at?.substring(0, 10)}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="completed">
                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                    Συμπλήρωσαν
                </mat-header-cell>
                <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">
                    <div fxLayout="column">
                        <div fxLayout="row"
                             fxLayoutAlign="center center center">{{calculateOpened(element.uniqueId)}}</div>
                        <div fxLayout="row" fxLayoutAlign="center center center">
                            <mat-icon [ngStyle]="{'color': 'green'}">stop</mat-icon>&nbsp;Συμπλήρωσαν
                        </div>
                    </div>

                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="pending">
                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef> Σε
                    αναμονή
                </mat-header-cell>
                <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">
                    <div fxLayout="column">
                        <div fxLayout="row"
                             fxLayoutAlign="center center center">{{calculatePending(element.uniqueId)}}</div>
                        <div fxLayout="row" fxLayoutAlign="center center center">
                            <mat-icon [ngStyle]="{'color': 'orange'}">stop</mat-icon>&nbsp;Σε αναμονή
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="reminder">
                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef> Ημ.
                    υπενθύμισης
                </mat-header-cell>
                <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">
                    <ng-container *ngIf="pendingReminderRequest; then LoadingReminder else ShowReminder"></ng-container>
                    <ng-template #ShowReminder>
                     <span *ngIf="element.reminder_date"
                           style="color: var(--primary); cursor: pointer; text-decoration: underline;"
                           (click)="showRemindersInfo(element)">
                    {{element.reminder_sent}}
                </span>

                    <span *ngIf="!element.reminder_date">
                    {{element.reminder_sent}}
                </span>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <ng-template #LoadingReminder>
                <div fxLayoutAlign="center center center">
                    <img src="assets/images/loading.gif" alt="loading" width="15" height="15" />
                </div>
            </ng-template>

            <ng-container matColumnDef="actions">
                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                    Ενέργειες
                </mat-header-cell>
                <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">

                    <div fxLayout="column" fxFlex="5">
                        <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">

                            <div fxLayout="row" fxLayoutAlign="center center center">

                                <button mat-icon-button>
                                    <mat-icon style="vertical-align: middle; color:var(--secondaryBlue);">
                                        more_vert
                                    </mat-icon>
                                </button>

                            </div>
                        </div>

                        <mat-menu #menu="matMenu">
                            <mat-list>
                                <mat-list-item class="menuList">
                                    <button matTooltip="Προβολή ολοκληρωμένων δηλώσεων" [disabled]="completed === 0"
                                            mat-menu-item (click)="showCompleted(element)">
                                        <mat-icon class="icon">visibility</mat-icon>&nbsp;Ολοκληρωμένες
                                    </button>
                                </mat-list-item>
                                <mat-list-item class="menuList">
                                    <button matTooltip="Εξαγωγή σε Excel" [disabled]="completed === 0" mat-menu-item
                                            (click)="exportToExcel(element)">
                                        <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε Excel
                                    </button>
                                </mat-list-item>
                                <mat-list-item class="menuList">
                                    <button mat-menu-item (click)="sendNotification(element)">
                                        <mat-icon class="icon">send</mat-icon>&nbsp;Αποστολή ενημέρωσης
                                    </button>
                                </mat-list-item>
                                <!--                                        <mat-list-item class="menuList" >-->
                                <!--                                            <button mat-menu-item (click)="navigateToDetails(reportAnnouncement)">-->
                                <!--                                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προβολή λεπτομερειών-->
                                <!--                                            </button>-->
                                <!--                                        </mat-list-item>-->
                                <!--                                        <mat-list-item class="menuList">-->
                                <!--                                            <button mat-menu-item (click)="notifyUsers(reportAnnouncement)">-->
                                <!--                                                <mat-icon class="icon">send</mat-icon>&nbsp;Αποστολή ενημέρωσης-->
                                <!--                                            </button>-->
                                <!--                                        </mat-list-item>-->
                            </mat-list>
                        </mat-menu>
                    </div>


                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
        </mat-table>
        <div *ngIf="isLoading">
            <app-skeleton-loading></app-skeleton-loading>
        </div>
    </div>
</div>


<!--<div *ngIf="!isLoading" fxLayout="row" fxLayoutAlign="center center center"-->
<!--         style="height: 100px;border-bottom:1px solid lightgray;">-->

<!--        <div fxFlex="5">&nbsp;</div>-->

<!--        <div fxFlex="30" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="start center center">Τίτλος</div>-->
<!--        <div fxFlex="10" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="start center center">-->
<!--            Ημ. Δημοσίευσης-->
<!--        </div>-->
<!--        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Συμπλήρωσαν-->
<!--        </div>-->
<!--        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Σε αναμονή-->
<!--        </div>-->

<!--        <div fxFlex="10" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Ημ. Υπενθύμισης-->
<!--        </div>-->
<!--        <div fxFlex="5"></div>-->
<!--    </div>-->

<!--    <div fxLayout="row wrap" fxLayoutAlign="center center center">-->
<!--        <div fxLayoutAlign="center center center"-->
<!--             style="height: 100px;border-bottom:1px solid lightgray;" fxFlex="100"-->
<!--             *ngFor="let reportAnnouncement of forms">-->

<!--            <div fxFlex="5">-->
<!--                <mat-icon>bookmark</mat-icon>-->
<!--            </div>-->

<!--            <div fxFlex="30" style="font-family: 'Century Gothic', sans-serif"-->
<!--                 fxLayoutAlign="start center center">{{reportAnnouncement.title}}</div>-->
<!--            <div fxFlex="10" style="font-family: 'Century Gothic', sans-serif"-->
<!--                 fxLayoutAlign="start center center">{{reportAnnouncement.published_at}}</div>-->
<!--            <div fxLayout="column" fxFlex="15">-->
<!--                <div fxLayout="row"-->
<!--                     fxLayoutAlign="center center center">{{calculateOpened(reportAnnouncement.uniqueId)}}</div>-->
<!--                <div fxLayout="row" fxLayoutAlign="center center center">-->
<!--                    <mat-icon [ngStyle]="{'color': 'green'}">stop</mat-icon>&nbsp;Συμπλήρωσαν-->
<!--                </div>-->
<!--            </div>-->

<!--            <div fxLayout="column" fxFlex="15">-->
<!--                <div fxLayout="row" fxLayoutAlign="center center center">{{calculatePending(reportAnnouncement.uniqueId)}}</div>-->
<!--                <div fxLayout="row" fxLayoutAlign="center center center">-->
<!--                    <mat-icon [ngStyle]="{'color': 'orange'}">stop</mat-icon>&nbsp;Σε αναμονή-->
<!--                </div>-->
<!--            </div>-->

<!--            <div fxFlex="10" style="font-family: 'Century Gothic', sans-serif"-->
<!--                 fxLayoutAlign="start center center">-->
<!--                <span *ngIf="reportAnnouncement.reminder_date" style="color: var(&#45;&#45;primary); cursor: pointer; text-decoration: underline;" (click)="showRemindersInfo(reportAnnouncement)">-->
<!--                    {{reportAnnouncement.reminder_sent}}-->
<!--                </span>-->

<!--                <span *ngIf="!reportAnnouncement.reminder_date">-->
<!--                    {{reportAnnouncement.reminder_sent}}-->
<!--                </span>-->

<!--            </div>-->
<!--            <div fxLayout="column" fxFlex="5">-->
<!--                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">-->
<!--                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>-->
<!--                        &lt;!&ndash;                  <label style="cursor: pointer;">Ενέργεια</label>&ndash;&gt;-->
<!--                        <button mat-flat-button [ngStyle]="{'background': 'transparent', 'color':'black'}"-->
<!--                                style="font-family: 'Century Gothic', sans-serif !important;">-->
<!--                            <mat-icon style="vertical-align: middle; color:var(&#45;&#45;haeforangePrimary);">-->
<!--                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}-->
<!--                            </mat-icon>-->
<!--                        </button>-->

<!--                    </div>-->

<!--                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>-->

<!--                        <button mat-icon-button>-->
<!--                            <mat-icon style="vertical-align: middle;">-->
<!--                                more_vert-->
<!--                            </mat-icon>-->
<!--                        </button>-->

<!--                    </div>-->
<!--                </div>-->

<!--                <mat-menu #menu="matMenu">-->
<!--                    <mat-list>-->
<!--                        <mat-list-item class="menuList">-->
<!--                            <button matTooltip="Προβολή ολοκληρωμένων δηλώσεων" [disabled]="completed === 0" mat-menu-item (click)="showCompleted(reportAnnouncement)">-->
<!--                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Ολοκληρωμένες-->
<!--                            </button>-->
<!--                        </mat-list-item>-->
<!--                        <mat-list-item class="menuList">-->
<!--                            <button matTooltip="Εξαγωγή σε Excel" [disabled]="completed === 0" mat-menu-item (click)="exportToExcel(reportAnnouncement)">-->
<!--                                <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε Excel-->
<!--                            </button>-->
<!--                        </mat-list-item>-->
<!--                        <mat-list-item class="menuList">-->
<!--                            <button disabled="true" mat-menu-item (click)="sendNotification(reportAnnouncement)">-->
<!--                                <mat-icon class="icon">send</mat-icon>&nbsp;Αποστολή ενημέρωσης-->
<!--                            </button>-->
<!--                        </mat-list-item>-->
<!--                    </mat-list>-->
<!--                </mat-menu>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div *ngIf="isLoading" fxFlex fxLayoutAlign="center center center" style="margin-top:50px; !important;">-->
<!--            <app-loading></app-loading>-->
<!--        </div>-->

<!--        <div *ngIf="forms.length === 0 && !isLoading">-->
<!--            <div style="margin-top: 50px; margin-bottom: 50px; font-family: 'Century Gothic', sans-serif;">-->
<!--                Δεν υπάρχουν αναφορές για δηλώσεις γονέων-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
